module.exports = __webpack_public_path__ + "static/media/ziegelofen_tn.6fc57602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/ziegelofen_tn.jpg
// module id = 784
// module chunks = 0